import { Button, Modal, Typography } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import React from 'react'

const { Text } = Typography;

export default function SuccessUpload({ open, onClose, reRnakFun }) {
    return (
        <Modal
            open={open}
            centered
            width={320}
            onCancel={() => onClose && onClose(false)}
            closeIcon={false}
            destroyOnClose
            footer={null}
            title={null}
            styles={{
                content: {
                    padding: '16px 18px',
                },
            }}
        >
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <CheckCircleFilled style={{ color: '#52c41a', fontSize: '18px' }} />
                    <Text strong style={{ fontSize: '14px', color: '#1f1f1f' }}>
                        File Uploaded Successfully
                    </Text>
                </div>
                <div style={{ paddingLeft: '26px', color: '#666', fontSize: '13px', lineHeight: '1.4' }}>
                    Click Rank to generate rankings.
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                    <Button type="primary" style={{ minWidth: '76px' }} onClick={reRnakFun}>
                        Rank
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
